
define('template!pimProductDetailImageView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(src !== '') { ;
__p += '\n    <img src="' +
((__t = ( src )) == null ? '' : __t) +
'">\n    ';
 if (placed) { ;
__p += '\n    <span class="pim-placed-badge ' +
((__t = ( placed.own ? 'is-own' : '' )) == null ? '' : __t) +
'" title="' +
__e( placed.title ) +
'">' +
((__t = ( placed.count )) == null ? '' : __t) +
'</span>\n    ';
 } ;
__p += '\n';
 } ;


}
return __p
};});

